import { render, staticRenderFns } from "./CompetitionEmptyLink.vue?vue&type=template&id=b072f156&scoped=true"
import script from "./CompetitionEmptyLink.vue?vue&type=script&lang=js"
export * from "./CompetitionEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b072f156",
  null
  
)

export default component.exports